import { Elevation } from '@blueprintjs/core';
import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { ContentCard, ContentCardHeader } from '../../../components/ContentCard';
import PaginatedTable from '../../../components/PaginatedTable';
import PaginationBar from '../../../components/PaginationBar';
import Text from '../../../components/Text';
import { useContactEmailsQuery } from '../../../generated/graphql';
import EmailListItem from '../../emails/components/EmailListItem';
import { dummyEmails } from '../../emails/dummy';

type RouteParams = {
  contactId?: string;
};

const ContactEmails = () => {
  const [emailPage, setEmailPage] = useState(1);
  const { contactId } = useParams<RouteParams>();
  const { data, loading, error } = useContactEmailsQuery({
    fetchPolicy: 'network-only',
    variables: {
      id: contactId || '',
      page: emailPage,
    },
  });

  const { data: emails, paginatorInfo } = data?.contact?.emails || {};
  const { currentPage, lastPage, hasMorePages } = paginatorInfo || {};

  return (
    <ContentCard elevation={Elevation.TWO} className="mb-5">
      <ContentCardHeader leftElement={<Text large>Emails</Text>} />
      <PaginatedTable
        columns={['Status', 'Betreff', 'Datum / Uhrzeit']}
        interactive
        loading={loading}
        hasError={!!error}
        empty={!emails?.length}
      >
        {(loading ? dummyEmails : emails || []).map((email) => (
          <EmailListItem key={email.id} item={email} skeleton={loading} />
        ))}
      </PaginatedTable>
      <PaginationBar
        loading={loading}
        empty={!emails?.length}
        currentPage={currentPage}
        lastPage={lastPage}
        hasMorePages={hasMorePages}
        onPrev={() => setEmailPage(currentPage && currentPage > 0 ? currentPage - 1 : 1)}
        onNext={() => setEmailPage(currentPage ? currentPage + 1 : 1)}
      />
    </ContentCard>
  );
};

export default ContactEmails;
